import { TextQueryValue } from "nystem-components";

const SelectQueryValue = (props) => <TextQueryValue {...props} />;

export default SelectQueryValue;
